<template>
    <div class="cerificatelist">
        <div class="operationBox">
            <div class="left">
                <el-button type="primary" @click="newCertificate">新建证书</el-button>
            </div>
            <div class="right">
                <el-input v-model="name" placeholder="请输入证书名称"></el-input>
                <el-button @click="triggerSearch">搜索</el-button>
            </div>
        </div>
        <el-table :data="tableData" style="width: 100%">
            <el-table-column label="证书名称" class-name="certificateName center">
                <template slot-scope="scope">
                    <div class="name">
                        {{scope.row.name}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="关联内容" class-name="center">
                <template slot-scope="scope">
                    <div class="relevanceContent">
                        <div class="left">
                            <img :src="scope.row.coverurl" alt="">
                        </div>
                        <div class="right">
                            <div class="relevancename">{{scope.row.kmcname}}</div>
                            <div class="type">{{scope.row.kmctypename}}</div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="certcount" label="发放量" class-name="center"></el-table-column>
            <el-table-column prop="datetime" label="创建时间" class-name="center"></el-table-column>
            <el-table-column label="操作" class-name="right">
                <template slot-scope="scope">
                    <div class="handle">
                        <div class="handle1" v-if="scope.row.status">
                            <span class="handleItem" @click="editCertificate(scope.row)">编辑</span>
                            <span class="line">|</span>
                            <span class="handleItem" @click="previewCertificate(scope.row)">预览</span>
                            <span class="line">|</span>
                            <span class="handleItem" @click="deleteCertificate(scope.row)">删除</span>
                        </div>
                        <div class="handle2" v-else>
                            <span class="handleItem" @click="checkCertificate(scope.row)">查看</span>
                        </div>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <page ref="page" :total="total" />
        <relevanceDialog ref="relevanceDialog" />
        <previewDialog ref="previewDialog" />
    </div>
</template>
<script>
import page from '@/base/page/page'
import relevanceDialog from './component/relevanceDialog.vue'
import previewDialog from './component/previewDialog.vue'
import {getCertinfoList, deleteCertInfo} from 'api/operateToolApi'
import {mapActions, mapGetters} from 'vuex'
export default {
    name: 'cerificatelist',
    data() {
        return {
            tableData: [],
            total: 0,
            name: ''
        }
    },
    created() {
        console.log(this.page)
        this.getCertinfoList()
    },
    methods: {
        // 查看证书
        checkCertificate(item) {
            this.$router.push({
                name: 'certificateEdit',
                query: {
                    kmcinnerid: item.kmcinnerid,
                    kmctype: item.kmctype,
                    innerid: item.innerid
                }
            })
        },
        // 编辑证书
        editCertificate(item) {
            this.$router.push({
                name: 'certificateEdit',
                query: {
                    kmcinnerid: item.kmcinnerid,
                    kmctype: item.kmctype,
                    innerid: item.innerid
                }
            })
        },
        // 预览证书
        previewCertificate(item) {
            this.$refs.previewDialog.open(item)
        },
        // 删除证书
        deleteCertificate(item) {
            this.$confirm('确定删除该证书吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.setLoading(true)
                deleteCertInfo({
                    data: {certinnerid: item.innerid},
                    success: res => {
                        this.setLoading(false)
                        item.status = 0
                    },
                    error: res => {
                        this.setLoading(false)
                        this.$message.error(res.msg)
                    }
                })
            }).catch(() => {
            })
        },
        triggerSearch() {
            this.setPage({page: 1, pageSize: 10})
            this.getCertinfoList()
        },
        newCertificate() {
            this.$refs.relevanceDialog.open()
        },
        getCertinfoList() {
            let params = {
                page: this.page.page,
                pageSize: this.page.pageSize,
                name: this.name
            }
            this.setLoading(true)
            getCertinfoList({
                data: params,
                success: res => {
                    this.setLoading(false)
                    this.tableData = res.data.content
                    this.total = res.data.pageinfo.rowCount
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setPage'
        ])
    },
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        page,
        relevanceDialog,
        previewDialog
    }
}
</script>
<style lang="scss">
    .cerificatelist {
        .operationBox {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 30px;
            .right {
                display: flex;
                align-items: center;
                .el-input {
                    width: 220px;
                    margin-right: 30px;
                }
            }
        }
        .el-table {
            .cell {
                color: #303133;
            }
            .certificateName {
                .cell {
                    width: 248px;
                }
            }
            .center {
                .cell {
                    text-align: center;
                }
            }
            .right {
                .cell {
                    text-align: right;
                }
            }
            .name {
                padding-left: 10px;
                font-size: 14px;
                width: 248px;
                text-align: left;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
            }
            .relevanceContent {
                display: flex;
                align-items: center;
                .left {
                    width: 106px;
                    height: 60px;
                    margin-right: 10px;
                    img {
                        width: 106px;
                        height: 60px;
                    }
                }
                .right {
                    height: 60px;
                    .relevancename {
                        font-size: 14px;
                        line-height: 18px;
                        width: 200px;
                        text-align: left;
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        -webkit-box-orient: vertical;
                        margin-bottom: 4px;
                    }
                    .type {
                        font-size: 14px;
                        color: #999999;
                        text-align: left;
                    }
                }
            }
            .handle {
                color: #439FFE;
                .line {
                    margin: 0 6px;
                }
                .handleItem {
                    cursor: pointer;
                }
            }
        }
    }
</style>